import { Search } from '@mui/icons-material'
import { Card, CardContent, Grid2, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import SelectChipIndicator from 'rpqs/components/managementEntity/SelectChipIndicator'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'
import CollectivityAction from 'rpqs/actions/CollectivityAction'
import { normalizeString } from 'utils/StringUtil'
import { getNumberFormat } from 'utils/NumberUtil'
import { ADD_ZONE, DELETE_ZONE } from 'rpqs/constants/RpqsConstant'

const ZoneTable = ({
    setCurrentZone=() => {},
    rows=[],
    setPanelTitle=() => {},
    setZoneToRemove=() => {},
}) => {
    const {
        managementEntity,
        zones,
    } = useSelector(store => ({
        managementEntity: store.CollectivityReducer.managementEntity,
        zones: store.CollectivityReducer.zones,
    }), shallowEqual)

    const dispatch = useDispatch()
    const year = getYear(managementEntity.dateEnd)

    const handleClickZone = (zone, i) => {
        setPanelTitle(undefined)
        setZoneToRemove(undefined)
        dispatch(CollectivityAction.updateZone(zone))
        setCurrentZone(i)
    }

    const handleChangeStatus = (zone, status) => {
        if (zone.status === status) return
        const newZone = { ...zone, status }

        const newZones = zones.map((z) => {
            if (z.id !== newZone.id) return z
            return newZone
        })
        dispatch(CollectivityAction.updateZones(newZones))
    }

    const handleRemoveZone = (zone) => {
        setZoneToRemove(zone)
        setPanelTitle(DELETE_ZONE)
    }

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell/>
                    <TableCell>{i18n.name}</TableCell>
                    <TableCell>{i18n.nbInhabitants}</TableCell>
                    <TableCell>{`${i18n.PpiceM3WaterIn} ${year-1}`}</TableCell>
                    <TableCell>{`${i18n.PpiceM3WaterIn} ${year}`}</TableCell>
                    <TableCell>{i18n.status}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((zone, i) => (
                    <TableRow
                        key={i}
                        sx={{
                            cursor: 'pointer',
                            '& td': {
                                borderBottom: 'none',
                            },
                        }}
                    >
                        <TableCell
                            sx={{ cursor: 'auto' }}
                        >
                            <IconButton
                                onClick={() => handleRemoveZone(zone)}
                            >
                                <DeleteOutlineIcon/>
                            </IconButton>
                        </TableCell>
                        <TableCell
                            onClick={() => handleClickZone(zone, i)}
                        >
                            {zone.name}
                        </TableCell>
                        <TableCell
                            onClick={() => handleClickZone(zone, i)}
                        >
                            {zone.nbHab && getNumberFormat(zone.nbHab)}
                        </TableCell>
                        <TableCell
                            onClick={() => handleClickZone(zone, i)}
                        >
                            {zone?.[year-1]?.servicePrice && getNumberFormat(zone?.[year-1]?.servicePrice)}
                        </TableCell>
                        <TableCell
                            onClick={() => handleClickZone(zone, i)}
                        >
                            {zone?.[year]?.servicePrice && getNumberFormat(zone?.[year]?.servicePrice)}
                        </TableCell>
                        <TableCell
                            sx={{
                                overflow: 'visible',
                                cursor: 'auto',
                                width: '200px',
                            }}
                        >
                            <SelectChipIndicator
                                indicatorStatus={zone?.status}
                                onChange={(status) => handleChangeStatus(zone, status)}
                            />
                        </TableCell>
                    </TableRow>

                ))}
            </TableBody>
        </Table>
    )
}

ZoneTable.propTypes = {
    setCurrentZone: PropTypes.func,
    rows: PropTypes.shape([]),
    setPanelTitle: PropTypes.func,
    setZoneToRemove: PropTypes.func,
}

const ZoneSelection = ({
    setCurrentZone=() => {},
    setPanelTitle=() => {},
    setZoneToRemove=() => {},
}) => {
    const {
        zones,
    } = useSelector(store => ({
        zones: store.CollectivityReducer.zones,
    }), shallowEqual)

    const [searchValue, setSearchValue] = useState('')
    const [filteredZones, setFilteredZones] = useState(zones)

    useEffect(() => {
        if (!normalizeString(searchValue)) {
            setFilteredZones(zones)
            return
        }

        setFilteredZones(
            zones.filter((z) => normalizeString(z.name).startsWith(normalizeString(searchValue))),
        )
    }, [zones, searchValue])

    const handleAddZone = () => {
        setPanelTitle(ADD_ZONE)
    }

    const handleSearch = (e) => {
        const value = e.target.value
        setSearchValue(value)
    }

    return (
        <Grid2
            container
            direction={'column'}
            gap={2}
        >
            <Typography
                pt={2}
                variant='h5'
            >
                {i18n.selectZoneToEdit}
            </Typography>
            <Card
                sx={{ flex: 1 }}
            >
                <CardTitle
                    title={'Zones tarifaire'}
                    actions={[
                    // Search input
                        <Grid2
                            container
                            key={'search'}
                            sx={{ position: 'relative', height: '36px' }}
                            py={'4px'}
                            direction={'column'}
                            justifyContent={'center'}
                        >
                            <input
                                placeholder={i18n.search}
                                className='no-margin'
                                onChange={handleSearch}
                            />
                            <Search
                                sx={{ position: 'absolute', right: '4px' }}
                            />
                        </Grid2>,
                        {
                            icon: 'file_download',
                            tooltip: 'export',
                        },
                        {
                            icon: 'note_add',
                            tooltip: 'add',
                            onClick: handleAddZone,
                        },
                    ]}
                />
                <CardContent>
                    <ZoneTable
                        setCurrentZone={setCurrentZone}
                        rows={filteredZones}
                        setPanelTitle={setPanelTitle}
                        setZoneToRemove={setZoneToRemove}
                    />
                </CardContent>
            </Card>
        </Grid2>
    )
}

ZoneSelection.propTypes = {
    setCurrentZone: PropTypes.func,
    setPanelTitle: PropTypes.func,
    setZoneToRemove: PropTypes.func,
}

export default ZoneSelection
